import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

// 人员管理
const moduleName = "roleSetting";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    async getRoleSetting({ commit }, payload) {
      var result = await api.get(
        `/api/Role/Page?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    async deleteRoleSetting({ commit }, payload) {
      var result = await api.delete(`/api/Role/Delete/${payload}`);
      return result.data;
    },
    async addRoleSetting({ commit }, payload) {
      var result = await api.post(`/api/Role/`, payload);
      return result.data;
    },
    async getRoleSettingView({ commit }, payload) {
      var result = await api.get(`/api/Role/GetRoleById/${payload}`);
      return result.data;
    },
    async editRoleSetting({ commit }, payload) {
      var result = await api.put(`/api/Role/Update/${payload.id}`, payload);
      return result.data;
    },
    // 控制开关
    async switchOnOff({ commit }, payload) {
      var result = await api.put(`/api/Role/${payload}`);
      return result.data;
    },
    // 获取所有的权限列表
    async getAllPermission({ commit }) {
      var result = await api.get(`/api/Permission?version=1`); //渔管理版本
      return result.data;
    },
    // 根据ID获取角色所有属性
    async getRoleById({ commit }, payload) {
      var result = await api.get(`/api/Role/GetRoleById/${payload}`);
      return result.data;
    }
  },
  mutations: {}
});

export default moduleName;
